import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { SynthesizeSpeechOutputFilterSensitiveLog, } from "../models/models_0";
import { de_SynthesizeSpeechCommand, se_SynthesizeSpeechCommand } from "../protocols/Aws_restJson1";
export { $Command };
export class SynthesizeSpeechCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("Parrot_v1", "SynthesizeSpeech", {})
    .n("PollyClient", "SynthesizeSpeechCommand")
    .f(void 0, SynthesizeSpeechOutputFilterSensitiveLog)
    .ser(se_SynthesizeSpeechCommand)
    .de(de_SynthesizeSpeechCommand)
    .build() {
}
